import { publicApi, admin2 } from '@/api/instance'

export const GetOrgs = async ({ code, name, limit } = {}) => {
  const res = await publicApi({
    method: 'get',
    url: '/org',
    params: {
      code,
      name,
      limit,
    },
  })

  return res.data
}

export const GetOrgsCount = async () => {
  const res = await publicApi({
    method: 'get',
    url: '/org/count',
  })

  return res.data.count
}

export const GetOrgsByCode = async ({ code }) => {
  const res = await publicApi({
    method: 'get',
    url: `/org/findOneByCode/${code}`,
  })

  return res.data
}

export const EmailLogin = async ({
  orgCode,
  email,
  password,
  agreeTerms,
  recaptchaVersion,
  recaptchaToken,
}) => {
  return await admin2({
    method: 'POST',
    url: '/user/login/byEmail',
    data: {
      orgCode,
      email,
      password,
      agreeTerms,
      recaptchaVersion,
      recaptchaToken,
    },
  })
}

export const LoginByUserAuthGrant = async ({
  orgCode,
  code,
}) => {
  return await admin2({
    method: 'POST',
    url: '/user/login/byUserAuthGrant',
    data: {
      orgCode,
      code,
    },
  })
}

export const Logout = async () => {
  return await admin2({
    method: 'post',
    url: '/user/logout',
  })
}

/**
 * 綁定或更新會員手機登入資訊 admin.member.updateAuthPhone
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 會員ID
 * @param {string} params.phone - 本地手機號碼
 * @param {string} [params.phoneCountryCode] - 國際碼
 * @param {string} [params.phoneCountry] - 國家 ISO alpha-2 代碼
 * @returns {Promise<Array>} 更新結果
 */
export const UpdateAuthPhone = async ({ shopId, id, phone, phoneCountryCode, phoneCountry }) => {
  const res = await admin2({
    method: 'put',
    url: `${shopId}/member/${id}/authPhone`,
    data: {
      phone,
      phoneCountryCode,
      phoneCountry,
    },
  })

  return res
}

export const DeleteAuthPhone = async ({ shopId, id }) => {
  const res = await admin2({
    method: 'delete',
    url: `${shopId}/member/${id}/authPhone`,
  })

  return res
}

//= > 搜尋店家會員
export const FindShopMember = async ({
  shopId,
  id,
}) => {
  const res = await admin2({
    method: 'get',
    url: `${shopId}/member/${id}`,
  })

  return res
}

// => 發送重設密碼信
export const SendForgetPasswordAuthnEmail = async ({ orgId, email }) => {
  return await admin2({
    method: 'POST',
    url: '/user/sendForgetPasswordAuthnEmail',
    data: {
      orgId,
      email,
    },
  })
}

export const GuestResetPassword = async ({
  orgId,
  forgetPasswordAuthnId,
  code,
  password,
}) => {
  return await admin2({
    method: 'POST',
    url: '/user/guestResetPassword',
    data: {
      orgId,
      forgetPasswordAuthnId,
      code,
      password,
    },
  })
}

export const VerifyForgetPasswordAuthn = async ({
  orgId,
  forgetPasswordAuthnId,
  code,
}) => {
  return await admin2({
    method: 'POST',
    url: '/user/verifyForgetPasswordAuthn',
    data: {
      orgId,
      forgetPasswordAuthnId,
      code,
    },
  })
}
